import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../lib/api";
import SEO from "../components/SEO";
import Divider from "../components/Divider";
import { Reveal } from "../components/Reveal";

const IMGS = [
  "https://images.pexels.com/photos/24748876/pexels-photo-24748876.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1585553616435-2dc0a54e271d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHxfMTc4NzI2MDA2Nnw&q=85",
  "https://images.pexels.com/photos/774454/pexels-photo-774454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

const CATS = ["Tutte", "Vino", "Persone", "Territori", "Horeca", "Dietro le quinte"];

export default function Storie() {
  const [articles, setArticles] = useState([]);
  const [cat, setCat] = useState("Tutte");

  useEffect(() => {
    client.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  const filtered = cat === "Tutte" ? articles : articles.filter((a) => a.category === cat);

  return (
    <div data-testid="storie-page">
      <SEO title="Storie — Il Blog" path="/storie"
           description="Racconti di vino, persone e territori: il blog di Dentro il Calice." />
      <section className="bg-nero pt-40 pb-20 grain relative">
        <div className="mx-auto max-w-5xl px-5 sm:px-8 text-center">
          <Reveal>
            <p className="text-oro text-xs uppercase tracking-[0.35em] mb-4">Il Blog</p>
            <h1 className="font-serif text-4xl sm:text-5xl font-bold text-panna">Storie dal calice</h1>
            <p className="mt-6 text-panna/70 max-w-xl mx-auto leading-relaxed">
              Vino, persone, territori. Racconti veri da trent'anni di cantine.
            </p>
            <Divider light className="mt-10" />
          </Reveal>
        </div>
      </section>
      <section className="bg-panna py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="flex flex-wrap gap-3 mb-14 justify-center" data-testid="category-filters">
            {CATS.map((c) => (
              <button key={c} data-testid={`cat-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setCat(c)}
                      className={`rounded-full px-5 py-2.5 text-sm font-medium transition-all border ${
                        cat === c ? "bg-bordeaux text-panna border-bordeaux" : "border-nero/20 text-nero/70 hover:border-bordeaux/50 hover:text-bordeaux"
                      }`}>
                {c}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {filtered.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 0.1}>
                <Link to={`/storie/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group block">
                  <div className="rounded-2xl overflow-hidden mb-5 aspect-[16/10]">
                    <img src={a.image || IMGS[i % 3]} alt={a.title} loading="lazy"
                         className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <span className="text-[0.65rem] uppercase tracking-[0.2em] text-oliva">{a.category} · {a.reading_time} min di lettura</span>
                  <h2 className="font-serif text-xl font-semibold text-nero mt-2 leading-snug group-hover:text-bordeaux transition-colors">{a.title}</h2>
                  <p className="mt-2 text-sm text-nero/60 leading-relaxed line-clamp-3">{a.excerpt}</p>
                </Link>
              </Reveal>
            ))}
          </div>
          {filtered.length === 0 && <p className="text-center text-nero/50 py-16">Nessuna storia in questa categoria, per ora.</p>}
        </div>
      </section>
    </div>
  );
}
